/**
 * App-wide replacement for React Native's Alert.alert, which is a no-op on
 * React Native Web and so silently swallowed every message the app tried to
 * show. These call through to AlertModal, mounted once at the app root.
 *
 * Deliberately a module rather than a hook: the alternative meant threading
 * context plumbing through twenty-odd component signatures for what is a
 * single app-wide surface. AppProvider registers the handlers on mount, so
 * plain functions and utilities can report to the user too.
 */

let handlers = null;

export const registerAlertHandlers = (next) => {
  handlers = next;
};

/**
 * @param {string} title
 * @param {string} message
 * @param {{ buttonText?: string, onDismiss?: function }} [options]
 */
export const showAlert = (title, message, options) => {
  if (!handlers) {
    // Before the provider mounts there is nowhere to draw it. Losing the
    // message is bad, losing it silently is what this whole change is about.
    console.warn("showAlert called before AppProvider mounted:", title, message);
    return;
  }
  // Tolerates a leftover Alert.alert button array being passed through.
  const opts = Array.isArray(options) ? undefined : options;
  handlers.showAlert(title, message, opts || {});
};

/**
 * Two-button question.
 * @param {{ title: string, message: string, confirmText?: string,
 *   cancelText?: string, destructive?: boolean, onConfirm?: function }} config
 */
export const showConfirm = (config) => {
  if (!handlers) {
    console.warn("showConfirm called before AppProvider mounted:", config?.title);
    return;
  }
  handlers.showConfirm(config);
};
